import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';

export default function DewPointCalc() {
  const [t, setT] = useState(25);
  const [tU, setTU] = useState('C');
  const [rh, setRh] = useState(60);

  const result = useMemo(() => {
    const Tc = tU === 'C' ? Number(t) : tU === 'F' ? (Number(t)-32)*5/9 : Number(t)-273.15;
    const a = 17.27, b = 237.7;
    const alpha = ((a * Tc) / (b + Tc)) + Math.log(Math.max(0.001, rh/100));
    const dpC = (b * alpha) / (a - alpha);
    return { C: dpC, F: dpC*9/5+32, K: dpC + 273.15 };
  }, [t, tU, rh]);

  return (
    <CalcShell look="cnet" title="Dew Point Calculator" subtitle="Compute dew point from air temperature and relative humidity.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Air Temperature</label>
            <div className="flex gap-2"><input type="number" step="0.1" value={t} onChange={e => setT(e.target.value)} className="flex-1"/>
              <select value={tU} onChange={e => setTU(e.target.value)}><option>C</option><option>F</option><option>K</option></select>
            </div>
          </div>
          <div className="field"><label>Relative Humidity (%)</label><input type="number" step="0.1" value={rh} onChange={e => setRh(e.target.value)}/></div>
        </div>
        <div>
          <div className="result-panel">
            <div className="result-title">Dew Point</div>
            <div className="result-value">{result.C.toFixed(2)}°C</div>
            <div className="text-sm text-slate-600 mt-1">{result.F.toFixed(2)}°F · {result.K.toFixed(2)} K</div>
          </div>
        </div>
      </div>
    </CalcShell>
  );
}
